var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsMac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M12.3669 8.5008C12.3461 6.47327 14.02 5.50297 14.0942 5.45428C13.1541 4.08057 11.6911 3.89161 11.1683 3.87075C9.92438 3.74323 8.73847 4.60339 8.10551 4.60339C7.47488 4.60339 6.49879 3.88813 5.4659 3.90668C4.10725 3.92755 2.85642 4.69729 2.15623 5.91219C0.745422 8.36053 1.79454 11.9867 3.16942 13.9748C3.84178 14.9462 4.64399 16.0371 5.69543 15.9988C6.70861 15.9583 7.09117 15.3427 8.3165 15.3427C9.54183 15.3427 9.88612 15.9988 10.9573 15.9791C12.0481 15.9583 12.7379 14.988 13.4045 14.0142C14.1765 12.8863 14.4942 11.7931 14.5139 11.7386C14.4884 11.7247 12.389 10.9213 12.3669 8.5008Z",
    fill: "#030104"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M10.3522 2.55499C10.9098 1.87915 11.2877 0.937835 11.1845 0C10.3788 0.0324591 9.40622 0.534415 8.82776 1.21142C8.30957 1.81075 7.85862 2.76714 7.97918 3.68642C8.87645 3.75714 9.79457 3.22968 10.3522 2.55499Z",
    fill: "#030104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsMac);
export default __webpack_public_path__ + "static/media/os-mac.479bf585462aaba07c909d8afa5dc113.svg";
export { ForwardRef as ReactComponent };